import {
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import * as Yup from "yup";
import { UserType, auth } from "service";
import { useFormik } from "formik";
import styles from "./dateinput.styles.module.css";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { IRootState } from "redux/types";
import { spreadsheetsLoadApplications } from "redux/slices/spreadsheets.slice";
import { useURLParamsSpreadsheets } from "hooks";
import { PageHeaderTitle } from "pages/components/page-header-title";
import { addNewSpreadsheet } from "service/api";
import { CreateOrderLoadingModal } from "../create-order-loading-modal";

export const RegistryTopSection = () => {
  const [isManager] = useState(auth.IsUserType(UserType.Manager));

  return (
    <>
      <Container
        sx={{
          mt: "48px",
        }}
      >
        <Box mb={"22px"}>
          <RegistryNameBlock />
        </Box>
        <Divider />
        {isManager ? (
          <Box mt={"12px"}>
            <RegistryFilterBlock />
          </Box>
        ) : null}
      </Container>
    </>
  );
};

const RedirectWithPostToForm = (tallyUrlWithParams) => {
  const getSpreadsheetId = (tallyUrlWithParams) => {
    const urlObj = new URL(tallyUrlWithParams);
    const params = new URLSearchParams(urlObj.search);

    const spreadsheetId = params.get('spreadsheet_id');
    const token = params.get('token');

    return { spreadsheetId, token }
  }

  const form = document.createElement('form');
  form.method = 'POST';
  const {spreadsheetId, token} = getSpreadsheetId(tallyUrlWithParams.link)
  form.action = String(process.env.REACT_APP_BACKEND2_HOST)+`/application/entry?token=${token}`;

  document.body.appendChild(form);
  form.submit();
};

const RegistryNameBlock = () => {
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line
  const [isDefaultUser] = useState(auth.IsUserType(UserType.Default));

  const onClickNewOrder = async () => {
    try {
      setLoading(true);
      const rdata = await addNewSpreadsheet();

      RedirectWithPostToForm(rdata)
      //window.location.replace(rdata.link);
    } catch (error) {
      alert(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <PageHeaderTitle title="Реестр заявок" />
      {/*{auth.GetUser()?.uid == "62bcb1a9-546c-4b06-923f-69124e8a390f" ? (*/}
      {isDefaultUser ?
        <Button variant="contained" onClick={onClickNewOrder}>
          + Новая заявка
        </Button>
       : null}
      <CreateOrderLoadingModal isLoading={loading} />
    </Box>
  );
};

const compensationTypes = [
  "Затраты на доставку транспортом",
  "Затраты на сертификацию предприятия",
  "Затраты на франчайзинг",
  "Затраты на соответствие товаров требованиям",
  "Затраты на регистрацию товарных знаков",
  "Затраты на аренду",
  "Затраты на перевод",
  "Затраты на рекламу товаров за рубежом",
  "Затраты на участие в выставках",
  "Затраты на рекламу ИКУ за рубежом",
  "Затраты на перевод каталога ИКУ",
  "Затраты на аренду помещения ИКУ",
  "Затраты на сертификацию ИКУ",
  "Затраты на демонстрацию ИКУ",
  "Затраты на участие в выставках ИКУ",
];

const limit = 10;

const RegistryFilterBlock = () => {
  const dispatch = useDispatch();
  const { spreadsheets } = useSelector(
    (state: IRootState) => state.spreadsheets,
    shallowEqual
  );
  const {
    page,
    bin,
    compensationType,
    signedAtFrom,
    signedAtUntil,
    companyName,
    applicationNo,
    applicationYear,
  } = useURLParamsSpreadsheets();

  const formik = useFormik({
    initialValues: {
      bin: bin.get(),
      compensation_type: compensationType.get(),
      signed_at_from: signedAtFrom.get(),
      signed_at_until: signedAtUntil.get(),
      company_name: companyName.get(),
      application_no: applicationNo.get(),
      application_year: applicationYear.get()
    },
    validationSchema: Yup.object().shape({
      bin: Yup.string().length(12),
    }),
    onSubmit: async (values) => {
      dispatch(
        spreadsheetsLoadApplications({
          offset: 0,
          limit: limit,
          bin: values.bin,
          compensation_type: values.compensation_type,
          signed_at_from: values.signed_at_from,
          signed_at_until: values.signed_at_until,
          application_no: Number(values.application_no),
          company_name: values.company_name,
          application_year: values.application_year,
        })
      );

      page.set("1");

      if (values.bin) bin.set(values.bin);
      else bin.rm();

      if (values.compensation_type)
        compensationType.set(values.compensation_type);
      else compensationType.rm();

      if (values.signed_at_from) signedAtFrom.set(values.signed_at_from);
      else signedAtFrom.rm();

      if (values.signed_at_until) signedAtUntil.set(values.signed_at_until);
      else signedAtUntil.rm();

      if (values.company_name) companyName.set(values.company_name);
      else companyName.rm();

      if (values.application_no) applicationNo.set(values.application_no);
      else applicationNo.rm();

      if (values.application_year) applicationYear.set(values.application_year);
      else applicationYear.rm();
    },
  });

  const isFilterAccepted = () => {
    if (formik.values.bin != bin.get()) return false;
    if (formik.values.compensation_type != compensationType.get()) return false;
    if (formik.values.signed_at_from != signedAtFrom.get()) return false;
    if (formik.values.signed_at_until != signedAtUntil.get()) return false;
    if (formik.values.company_name != companyName.get()) return false;
    if (formik.values.application_no != applicationNo.get()) return false;
    if (formik.values.application_year != applicationYear.get()) return false;
    return true;
  };

  return (
    <Box>
      <Typography fontSize={"16px"} lineHeight={"20px"} fontWeight={"600"}>
        Фильтр
      </Typography>
      <Typography
        sx={{
          display: isFilterAccepted() ? "none" : "block",
        }}
        color={"red"}
      >
        Указанный вами фильтр не применен. Нажмите кнопку "Применить фильтр".
      </Typography>
      <Box mt={"8px"}>
        <form onSubmit={formik.handleSubmit}>
          <Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: "8px",
              }}
            >
              <TextField
                label="Номер заявки"
                size="small"
                name="application_no"
                error={formik.errors["application_no"] ? true : false}
                value={formik.values.application_no}
                onChange={formik.handleChange}
                placeholder="Введите номер заявки"
              />
              <TextField
                label="Название компании"
                size="small"
                name="company_name"
                error={formik.errors["company_name"] ? true : false}
                value={formik.values.company_name}
                onChange={formik.handleChange}
                placeholder="Введите название компании"
              />

              <TextField
                label="БИН"
                size="small"
                name="bin"
                error={formik.errors["bin"] ? true : false}
                value={formik.values.bin}
                onChange={formik.handleChange}
                placeholder="Введите БИН"
              />
              <FormControl
                size="small"
                sx={{
                  minWidth: "200px",
                }}
              >
                <InputLabel id="refund-type-label">Тип возмещения</InputLabel>
                <Select
                  labelId="refund-type-label"
                  id="refund-type-select"
                  name="compensation_type"
                  value={formik.values.compensation_type}
                  onChange={formik.handleChange}
                  sx={{
                    borderRadius: "8px",
                  }}
                >
                  <MenuItem value="">
                    <em>Не выбран</em>
                  </MenuItem>
                  {compensationTypes.map((t) => {
                    return (
                      <MenuItem key={t} value={t}>
                        {t}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>

              <Box
                sx={{
                  display: "inherit",
                  flexDirection: "inherit",
                  flexWrap: "inherit",
                  gap: "inherit",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Typography sx={{ mr: "4px" }}>
                    Дата подписания от:
                  </Typography>
                  <input
                    className={styles["input-date"]}
                    name="signed_at_from"
                    value={formik.values.signed_at_from}
                    type="date"
                    onChange={formik.handleChange}
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Typography sx={{ mr: "4px" }}>
                    Дата подписания до:
                  </Typography>
                  <input
                    className={styles["input-date"]}
                    name="signed_at_until"
                    value={formik.values.signed_at_until}
                    type="date"
                    onChange={formik.handleChange}
                  />
                </Box>
              </Box>
            </Box>

            <Button
              sx={{ mt: "8px" }}
              type="submit"
              variant="contained"
              size="small"
              color={isFilterAccepted() ? "inherit" : "primary"}
              disabled={
                Object.values(formik.errors).length || spreadsheets.loading
                  ? true
                  : false
              }
            >
              Применить фильтр
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
};
